import { render, staticRenderFns } from "./MenuManagementTable.vue?vue&type=template&id=34b37846"
import script from "./MenuManagementTable.vue?vue&type=script&lang=js"
export * from "./MenuManagementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports